import React from "react";
import { Card } from "reactstrap";


export const CUGHeader = (props) => <Card className="cug-report-header">
    <h5>RUBIX CLOSED USER GROUP (CUG) PAYMENT REPORT</h5>
    <h3><b>{props.counterpartyName}</b></h3>
</Card>